<rappider-spin [spinning]="!editingModule">
  <rappider-crud-view-edit-form [config]="MODULE_EDIT_CONFIG"
                                [data]="editingModule"
                                [submitButtonLoading]="submitButtonLoading"
                                (formSubmit)="onEditModuleFormSubmit($event)"></rappider-crud-view-edit-form>
</rappider-spin>
